import { useCallback } from "react";

import { PAYMENT_STATUS_LABELS } from "@/constants/payment.constants";
import { useT } from "@/i18n";
import { PaymentStatus } from "@/types";

export const useGetPaymentStatusLabel = () => {
  const t = useT();

  const getPaymentStatusLabel = useCallback(
    (status: PaymentStatus) => {
      return t(PAYMENT_STATUS_LABELS[status]);
    },
    [t]
  );

  return getPaymentStatusLabel;
};
